import template from '@components/expertise/discovery/discovery.module.scss'
import Breadcrumbs from '@components/shared/miscellaneous/breadcrumbs/breadcrumbs';
import style from './index.module.scss'
import Image from 'next/image'
import { IPreviewSection } from '../../discovery.state';
import { TextImageBlock } from '@components/shared/blocks/text-image-block';

interface IPreviewSectionProps {
    section: IPreviewSection;
}

const PreviewSectionComponent = ({ section }: IPreviewSectionProps) => {
    const moneySavingLastElement = section.moneySavingText.length - 1;

    return(
        <>
            <Breadcrumbs />
            <section className={`${template.section} ${template.section__block_light} ${template.section__block_light__first}`}>
                <div className={template.container}>
                    <TextImageBlock title={section.title} text={section.text} imageSrc={section.imgSrc} imageAlt={section.title}/>
                    <div className={`${style.textblock}`}>
                        <div className={`${style.textblock__flex}`}>
                            <div className={`${style.textblock__flex__item} ${style.textblock__flex__item_first} ${style.textblock__flex__item__title}`}>
                                {section.moneySavingTitle}
                            </div>
                            <div className={`${style.textblock__flex__item} ${style.textblock__flex__item_second}`}>
                                {
                                    section.moneySavingText.map((item: string, index: number) => {
                                        return (
                                            <p className={`${index === moneySavingLastElement ? null : style.textSaving}`} key={index}>
                                                {item}
                                            </p>
                                        )
                                    })
                                }
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>
    )
}

export default PreviewSectionComponent;
